import React, { useContext } from "react";
import { Accordion, Loading, TitleBar } from "modules/common";
import { useGetRegistriesByPgs } from "modules/common/hooks/dippHooks";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Registry {
    id: number;
    name: string;
}

interface Props {
    mibpg: string;
}

export const Registries: React.FC<Props> = ({ mibpg }) => {
    const { data, isFetching: isLoading } = useGetRegistriesByPgs(mibpg);
    const { fontSize } = useContext(AccessibilityContext);

    return (
        <div>
            <TitleBar>
                <TitleBar.Left>
                    <span className="title-bar-text profile-title" style={{ fontSize: `${fontSize}%` }}>PRIPADNOST REGISTRIMA</span>
                </TitleBar.Left>
                <TitleBar.Right>
                    <span className="title-bar-description" style={{ fontSize: `${fontSize}%` }}>Izvor podataka: SEMIS</span>
                </TitleBar.Right>
            </TitleBar>
            {isLoading && <Loading size="small" />}
            {data && Object.keys(data).length > 0 ? (
                Object.entries(data).map(([pgName, registries]) => (
                    <Accordion
                        key={pgName}
                        title={pgName}
                        className="registries-accordion"
                        isButtonWithBorder
                    >
                        <ul className="registries-list">
                            {(registries.length > 0) ? registries.map((registry: Registry) => (
                                <li key={registry.id}>{registry.name}</li>
                            )) : <div className="no-registries">Ne pripada nijednom registru</div> }
                        </ul>
                    </Accordion>
                ))
            ) : (
                <div className="no-registries">Nema registriranih gospodarstva</div>
            )}
        </div>
    );
};